import { render, staticRenderFns } from "./mCategoryView2.vue?vue&type=template&id=78b2e737"
import script from "./mCategoryView2.vue?vue&type=script&lang=js"
export * from "./mCategoryView2.vue?vue&type=script&lang=js"
import style0 from "./mCategoryView2.vue?vue&type=style&index=0&id=78b2e737&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports